import React from 'react';
import ReactDOM from 'react-dom';
import 'moment/locale/zh-cn';
import zhCN from 'antd/lib/locale/zh_CN';
import { ConfigProvider } from 'antd';
import { isMobile } from './util/index';
import { BrowserRouter } from 'react-router-dom';
import './style/index.less';
// import { ApolloProvider } from '@apollo/react-hooks';
// import client from './util/graphql-client';

ConfigProvider.config({
    prefixCls: 'qup-home',
});

function loadApp({ default: App }) {
    ReactDOM.render(
        <React.StrictMode>
            <ConfigProvider locale={zhCN} prefixCls="qup-home">
                <BrowserRouter>
                    {/* <ApolloProvider client={client}> */}
                        <App />
                    {/* </ApolloProvider> */}
                </BrowserRouter>
            </ConfigProvider>
        </React.StrictMode>,
        document.getElementById('mainApp'),
    );
}

if (isMobile) {
    import('./view/m/main').then(loadApp);
} else {
    import('./view/pc/main').then(loadApp);
}

